import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

import { httpOk, GET } from 'helpers/api'

// Вместо стрелки у поля точки — лупа, чтобы поле читалось как поиск
function SearchIndicator() {
	return (
		<div className="tasks-select-search-icon">
			<i className="uil uil-search"></i>
		</div>
	)
}

// Одно поле «Торговая точка» с поиском по названию, ID и логину клиента.
// Используется и в модалке создания, и в фильтре доски, чтобы выбор был одинаковым
function PosSearchSelect({
	apiPrefix,
	value,
	onChange,
	styles = undefined,
	placeholder = '',
}) {
	const { t } = useTranslation()

	const [poses, setPoses] = useState([])
	const [posesLoading, setPosesLoading] = useState(false)

	const searchTimerRef = useRef(null)

	async function getPoses(search = '') {
		setPosesLoading(true)
		const url = `${apiPrefix}/helper/task-client-poses` + (search ? '?search=' + encodeURIComponent(search) : '')
		const response = await GET(url, {}, { loader: false })
		if (httpOk(response)) setPoses(response.data || [])
		setPosesLoading(false)
	}

	function handleSearch(search, action) {
		// react-select дёргает onInputChange ещё и на blur/menu-close с пустой строкой
		if (action && action.action !== 'input-change') return

		if (searchTimerRef.current) clearTimeout(searchTimerRef.current)
		searchTimerRef.current = setTimeout(() => {
			getPoses(search)
		}, 500)
	}

	// В выбранном значении — одна строка, в списке — две: название точки и реквизиты
	function formatPosOption(option, meta) {
		const title = option.name || option.short_name || option.login

		if (meta.context === 'value') {
			return <span>{title + ' · ID ' + option.id}</span>
		}

		return (
			<div className="tasks-select-option">
				<div className="tasks-select-option-title">{title}</div>
				<div className="tasks-select-option-sub">
					<span>ID {option.id}</span>
					<span>{option.login}</span>
					{option.client_name && <span>{option.client_name}</span>}
				</div>
			</div>
		)
	}

	useEffect(() => {
		getPoses()

		return () => {
			if (searchTimerRef.current) clearTimeout(searchTimerRef.current)
		}
	}, [apiPrefix]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Select
			isClearable
			isLoading={posesLoading}
			styles={styles}
			components={{ DropdownIndicator: SearchIndicator }}
			options={poses}
			value={value || ''}
			onChange={(option) => onChange(option)}
			onInputChange={(search, action) => handleSearch(search, action)}
			filterOption={() => true}
			placeholder={placeholder}
			noOptionsMessage={() => t('list_empty')}
			formatOptionLabel={(option, meta) => formatPosOption(option, meta)}
			getOptionLabel={(option) => (option.name || option.login) + ' · ID ' + option.id}
			getOptionValue={(option) => option.id}
		/>
	)
}

export default PosSearchSelect
